import { Module } from "@/constants";
import { useMemo } from "react";
import { usePermissions } from "./usePermissions";
import { ModulePermissionsMap } from "@/types/permissions";
import { useLocation } from "react-router-dom";

export const useModulePermissions = <M extends Module>(
  module?: M,
): ModulePermissionsMap[M] => {
  const { pathname } = useLocation();
  const moduleName = (module || findModuleName(pathname)) as M;
  const allPermissions = usePermissions();

  const modulePermissions = useMemo(() => {
    const isValidModule =
      moduleName && Object.values(Module).includes(moduleName as Module);

    if (isValidModule) {
      return allPermissions[moduleName as Module] as ModulePermissionsMap[M];
    }

    throw new Error(`Module ${moduleName} not found`);
  }, [allPermissions, moduleName]);

  return modulePermissions;
};

const findModuleName = (pathname: string): Module | undefined => {
  const parts = pathname.split("/").reverse();
  const moduleName = parts.find((part) =>
    Object.values(Module).includes(part as Module),
  );
  return moduleName as Module;
};
